import React from 'react';

const serverError = {
  icon: null,
  header: (
    <span className="errorMessageHeader">
      <img
        src="https://assets.thdstatic.com/images/v1/path-to-pro/warning-triangle.svg"
        alt="warning-triangle"
        className="p2p-error-message__icon"
      />
      <span>Oops!</span>
    </span>
  ),
  message: (
    <p className="p">
      Something went wrong on our side. Unable to complete your request.{' '}
      <span className="slm__styled-text--orange">
        Please refresh your browser and try again.
      </span>
    </p>
  )
};

const ErrorMessage = (props) => {
  const { icon, header, message } = props;

  return (
    <div>
      {icon}
      <p className="p2p-error-message__header">{header}</p>
      <p className="p2p-error-message__message">{message}</p>
    </div>
  );
};

export const ServerErrorMessage = () => <ErrorMessage {...serverError} />;

export default ErrorMessage;
